import { render } from "./growthCenter.vue?vue&type=template&id=0719b720&scoped=true"
import script from "./growthCenter.vue?vue&type=script&lang=js"
export * from "./growthCenter.vue?vue&type=script&lang=js"

import "./growthCenter.vue?vue&type=style&index=0&id=0719b720&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0719b720"]])

export default __exports__